import { PartialId } from '@attain-apps/string-builder'

import * as core from '../../../../../../../../../core'
import * as engagement from '../engagement'

export const RESOURCE = {
  payload: {
    canBeOptional: true,
    context: core.dms.models.Attribute.Id.Context.from({
      context: engagement.RESOURCE.payload.dimension.partialId,
      partialId: engagement.RESOURCE.payload.partialId,
      type: core.dms.models.Type.Entity,
    }),
    description:
      'Indicates whether this engagement is currently active for the employee.',
    isOptional: true,
    name: 'Is Current',
    partialId: PartialId.Standard.create('is_current'),
    type: core.common.value.types.Intrinsic.Boolean,
  },
  type: core.quiver.Resource.Type.DmsAttribute,
} as const satisfies core.quiver.Resource<core.quiver.Resource.Type.DmsAttribute>
